import { useMemo, useState } from 'react'
import { Element } from '../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'

export const SearchListItem = ({ data, onClickItem }) => {
  const [isHover, setIsHover] = useState(false)

  const getItemBgColor = useMemo(() => {
    return isHover ? '#C8E3FF' : '#F3F3F3'
  }, [isHover])

  const onMouseEnter = () => {
    setIsHover(true)
  }

  const onMouseLeave = () => {
    setIsHover(false)
  }

  const onHandleClickItem = () => {
    onClickItem(data)
  }

  return (
    <Element
      style={{ backgroundColor: getItemBgColor }}
      className="dFlex alignItemsCenter p1 cursorPointer"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onHandleClickItem}
    >
      <Element className="w100 dFlex" style={{ fontSize: 10 }}>
        <span
          style={{
            paddingRight: 8,
            borderRightWidth: 1,
            borderRightColor: '#9C9C9C',
            borderRightStyle: 'solid',
          }}
        >
          {data.taxCode}
        </span>
        {data.ticker && (
          <span
            style={{
              paddingRight: 8,
              borderRightWidth: 1,
              borderRightColor: '#9C9C9C',
              borderRightStyle: 'solid',
            }}
          >
            {data.ticker}
          </span>
        )}
        <TextEllipsisStaticLine
          text={data.organizationName}
          isI18n={false}
          lineClamp={1}
          zIndexTooltip={13}
          appendStyle={{
            paddingLeft: 8,
            textTransform: 'uppercase',
          }}
        />
      </Element>
    </Element>
  )
}
